// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandler, createHandlerChainRunner, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { getProductCollectionV2 } from "@insite/client-framework/Services/ProductServiceV2";
import { ProductCollectionModel, ProductModel } from "@insite/client-framework/Types/ApiModels";

type LoadProductsParameter = {
    productsNumber: string[];
    onError?: (error: string) => void;
} & HasOnSuccess<ProductModel[]>;

type HandlerType = ApiHandler<LoadProductsParameter, ProductCollectionModel>;

export const RequestDataFromApi: HandlerType = async props => {
    const parameter = { additionalQueryStringParameters: { extendedNames: props.parameter.productsNumber } };
    try {
        props.apiResult = await getProductCollectionV2(parameter);
    } catch (error) {
        props.parameter.onError?.((error as any).errorMessage);
        return (error as any).errorMessage;
    }
};

export const DispatchCompleteGetProductsByNumber: HandlerType = (props: any) => {
    if (!props.apiResult.products || !props.apiResult.products.length) {
        return props.parameter.onError?.("Product Not Found");
    }

    props.parameter.onSuccess(props.apiResult.products);
};

export const chain = [RequestDataFromApi, DispatchCompleteGetProductsByNumber];

const getProductsByNumber = createHandlerChainRunner(chain, "GetProductsByNumber");

export default getProductsByNumber;
